import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Sign a sub-app in as whoever opens it, from their own shell session, never
// from a ?token= in the URL: links people share carry the SENDER's token,
// which expires after 15 minutes and must never sign the recipient in as the
// sender. The route must be wrapped in ProtectedRoute (App.js), which waits
// for the session and sends signed-out visitors to /login and back again.
//
// Also drops token/user/role from the address bar (bookmarks and links shared
// before this carry them), so a copied URL is a clean link anyone can open.
// Through the router, rebuilt from the address bar: a raw
// history.replaceState never reaches the router, and the next tab click
// would write the old params back.
export const useSessionLaunch = () => {
  const { token, user } = useAuth();
  const navigate = useNavigate();
  // The first token only: the app's provider refreshes it itself (see
  // useAuthRefresh), so the shell's 12-minute refresh doesn't re-create every
  // callback that depends on it.
  const [launchToken] = useState(token);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let dirty = false;
    for (const k of ['token', 'user', 'role']) {
      if (params.has(k)) { params.delete(k); dirty = true; }
    }
    if (dirty) navigate({ search: params.toString(), hash: window.location.hash }, { replace: true });
  }, [navigate]);

  return {
    token: launchToken,
    username: user?.full_name || user?.username || 'User',
    role: user?.role || 'user'
  };
};

export default useSessionLaunch;
